import { render, staticRenderFns } from "./UcPaymentHeader.yaml?vue&type=template&id=74099fa5&component"
import script from "./UcPaymentHeader.yaml?vue&type=script&lang=ts&component"
export * from "./UcPaymentHeader.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports